import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { PRIMARY } from '../../../../shared/colors';

type LayoutType = Parameters<typeof Form>[0]['layout'];

export const ContactForm = () => {
  const [form] = Form.useForm();
  const [formLayout] = useState<LayoutType>('vertical');
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Form
      layout={formLayout}
      form={form}
      labelCol={{ span: 20 }}
      wrapperCol={{ span: 25 }}
      initialValues={{}}
      scrollToFirstError
      onFinish={async (data) => {
        setIsLoading(true);
        setTimeout(() => {
          notification.success({
            message: 'Succès',
            description:
              'Votre message a bien été transmit. Nous vous remercions',
          });
          form.resetFields();
          setIsLoading(false)
        }, 2000)
        // if (response.success) {
        //   notification.success({
        //     message: 'Succès',
        //     description:
        //       'Votre message a bien été transmit. Nous vous remercions',
        //   });
        //   form.resetFields();
        // } else {
        //   notification.error({
        //     message: 'Erreur',
        //     description: 'Une erreur est survenu. Veuillez reéssayer',
        //   });
        // }
        // setIsLoading(false);
      }}
    >
      <Form.Item label='Adresse' name='adresse'>
        <Input placeholder='adresse' />
      </Form.Item>
      <Form.Item label='Téléphone' name='telephone'>
        <Input placeholder='téléphone' />
      </Form.Item>
      <Form.Item
        label='Mail'
        name='email'
        hasFeedback
        rules={[
          {
            required: true,
            type: 'email',
            message: 'Votre email doit être précisé',
          },
        ]}
      >
        <Input placeholder='adresse mail' />
      </Form.Item>

      <Form.Item label='Message' name='message'>
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item>
        <Button
          type='primary'
          htmlType='submit'
          loading={isLoading}
          size='large'
          style={{ width: '100%', backgroundColor: PRIMARY, borderWidth: 0 }}
        >
          Envoyer
        </Button>
      </Form.Item>
    </Form>
  );
};
